<template>
  <div class="message-dialog">
    <!-- 左侧tab切换 -->
    <div class="left-tabs">
      <div class="tab-item" :class="{ active: activeTab === 'platform' }" @click="activeTab = 'platform'">
        <img class="tab-icon-img" :src="activeTab === 'platform' ? systemActiveIcon : systemInactiveIcon" />
        <span class="tab-label">系统消息</span>
        <span class="badge" v-if="applyVerifyNum != '0'">{{ applyVerifyNum }}</span>
      </div>

      <div class="tab-item" v-if="role == 'purchase'" :class="{ active: activeTab === 'purchase' }" @click="activeTab = 'purchase'">
        <img class="tab-icon-img" :src="activeTab === 'purchase' ? reviewActiveIcon : reviewInactiveIcon" />
        <span class="tab-label">待你审核消息</span>
        <span class="badge" v-if="role == 'purchase' && purchaseNum != '0'">{{ purchaseNum }}</span>
      </div>

      <div class="tab-item" v-if="role == 'supplier'" :class="{ active: activeTab === 'supplier' }" @click="activeTab = 'supplier'">
        <img class="tab-icon-img" :src="activeTab === 'supplier' ? reviewActiveIcon : reviewInactiveIcon" />
        <span class="tab-label">申请审核消息</span>
        <span class="badge" v-if="role == 'supplier' && supplierNum != '0'">{{ supplierNum }}</span>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="divider"></div>

    <!-- 右侧内容区 -->
    <div class="right-content">
      <!-- 系统消息 -->
      <template v-if="activeTab === 'platform'">
        <div v-if="platformList.length != 0">
          <div class="msg-card" v-for="(item, index) in platformList" :key="index">
            <div class="card-header">
              <span class="bullet" v-show="!item.whetherRead"></span>
              <span class="card-title">{{ item.title }}</span>
              <span class="toggle-btn" @click="item.expanded = !item.expanded">
                {{ item.expanded ? "收起" : "展开" }}
                <img class="toggle-icon-img" :class="{ 'toggle-icon-rotated': item.expanded }" :src="toggleIcon" />
              </span>
            </div>
            <div class="card-body" v-show="item.expanded">
              <div class="card-text">{{ item.content }}</div>
            </div>
          </div>
          <el-pagination
            class="msg-pagination"
            @size-change="handleSizeChange('platform', $event)"
            @current-change="handlePageChange('platform', $event)"
            :current-page="platformPageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="platformPageSize"
            :total="platformTotal"
            layout="total, sizes, prev, pager, next"
            background
          />
        </div>
        <div v-else style="margin-top: 100px"><el-empty description="消息为空"></el-empty></div>
      </template>

      <!-- 采购商-待你审核消息 -->
      <template v-if="activeTab === 'purchase'">
        <div v-if="purchaseList.length != 0">
          <div class="msg-card review-card" v-for="(item, index) in purchaseList" :key="index">
            <div class="review-content">
              <span class="bullet" v-show="!item.whetherRead"></span>
              <span class="review-title">{{ item.title }}：</span>
              <span class="review-text">{{ item.content }}</span>
              <div class="detail-link" @click="goOrder(item)">
                <div>详情</div>
                <img style="width: 18px; height: 18px" src="@/assets/image/rightIcon.png" />
              </div>
            </div>
          </div>
          <el-pagination
            class="msg-pagination"
            @size-change="handleSizeChange('purchase', $event)"
            @current-change="handlePageChange('purchase', $event)"
            :current-page="purchasePageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="purchasePageSize"
            :total="purchaseTotal"
            layout="total, sizes, prev, pager, next"
            background
          />
        </div>
        <div v-else style="margin-top: 100px"><el-empty description="消息为空"></el-empty></div>
      </template>

      <!-- 供应商-待你审核消息 -->
      <template v-if="activeTab == 'supplier'">
        <div v-if="supplierList.length != 0">
          <div class="msg-card review-card" v-for="(item, index) in supplierList" :key="index">
            <div class="review-content">
              <span class="bullet" v-show="!item.whetherRead"></span>
              <span class="review-title">{{ item.title }}：</span>
              <span class="review-text">{{ item.content }}</span>
              <div class="detail-link" @click="goOrder(item)">
                <div>详情</div>
                <img style="width: 18px; height: 18px" src="@/assets/image/rightIcon.png" />
              </div>
            </div>
          </div>
          <el-pagination
            class="msg-pagination"
            @size-change="handleSizeChange('supplier', $event)"
            @current-change="handlePageChange('supplier', $event)"
            :current-page="supplierPageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="supplierPageSize"
            :total="supplierTotal"
            layout="total, sizes, prev, pager, next"
            background
          />
        </div>
        <div v-else style="margin-top: 100px"><el-empty description="消息为空"></el-empty></div>
      </template>
    </div>
  </div>
</template>

<script>
import { getMyMessageList, getMessageUnreadStat, batchSetRead } from "@/api/message";

import systemActiveIcon from "@/assets/image/set2.png";
import systemInactiveIcon from "@/assets/image/set1.png";
import reviewActiveIcon from "@/assets/image/menuIcon55.png";
import reviewInactiveIcon from "@/assets/image/menuIcon5.png";
import toggleIcon from "@/assets/image/top-icon.png";

export default {
  name: "MessageDialog",
  data() {
    return {
      systemActiveIcon,
      systemInactiveIcon,
      reviewActiveIcon,
      reviewInactiveIcon,
      toggleIcon,
      activeTab: "platform",
      role: "", // supplier=供应商,purchase=采购方
      purchaseList: [],
      platformList: [],
      supplierList: [],
      applyVerifyNum: "0", // 系统消息
      purchaseNum: "0", // 采购商消息
      supplierNum: "0", // 供应商消息
      // 分页
      platformPageNum: 1,
      platformPageSize: 5,
      platformTotal: 0,
      purchasePageNum: 1,
      purchasePageSize: 5,
      purchaseTotal: 0,
      supplierPageNum: 1,
      supplierPageSize: 5,
      supplierTotal: 0,
    };
  },
  methods: {
    goOrder(item) {
      batchSetRead(item.messageId).catch(() => {});
      this.$router.push(`/demand-detail/${item.relationNo}`);
      this.$emit("close");
    },

    async getMessageUnreadStatFun() {
      const res = await getMessageUnreadStat();
      if (res.code == "200") {
        res.data.unreadItems.forEach((item) => {
          if (item.itemName == "platform") {
            this.applyVerifyNum = item.itemValue;
          }
          if (item.itemName == "purchase") {
            this.purchaseNum = item.itemValue;
          }
          if (item.itemName == "supplier") {
            this.supplierNum = item.itemValue;
          }
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    async getMyMessageListFun(type) {
      let pageNum, pageSize;
      if (type == "platform") {
        pageNum = this.platformPageNum;
        pageSize = this.platformPageSize;
      } else if (type == "purchase") {
        pageNum = this.purchasePageNum;
        pageSize = this.purchasePageSize;
      } else if (type == "supplier") {
        pageNum = this.supplierPageNum;
        pageSize = this.supplierPageSize;
      }

      let params = {
        type: type,
        pageNum: pageNum,
        pageSize: pageSize,
      };

      const res = await getMyMessageList(params);
      if (res.code == "200") {
        if (type == "purchase") {
          this.purchaseList = res.rows;
          this.purchaseTotal = res.total || 0;
        }
        if (type == "platform") {
          this.platformList = res.rows;
          this.platformTotal = res.total || 0;
          this.platformList.forEach((item) => {
            this.$set(item, "expanded", false);
          });
        }
        if (type == "supplier") {
          this.supplierList = res.rows;
          this.supplierTotal = res.total || 0;
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    handlePageChange(type, page) {
      if (type == "platform") this.platformPageNum = page;
      else if (type == "purchase") this.purchasePageNum = page;
      else if (type == "supplier") this.supplierPageNum = page;
      this.getMyMessageListFun(type);
    },
    handleSizeChange(type, size) {
      if (type == "platform") {
        this.platformPageSize = size;
        this.platformPageNum = 1;
      } else if (type == "purchase") {
        this.purchasePageSize = size;
        this.purchasePageNum = 1;
      } else if (type == "supplier") {
        this.supplierPageSize = size;
        this.supplierPageNum = 1;
      }
      this.getMyMessageListFun(type);
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.getMyMessageListFun("platform");
    this.getMessageUnreadStatFun();
  },
  watch: {
    // 监听 message 的变化
    activeTab: function (newVal) {
      console.log(newVal);
      this.getMyMessageListFun(newVal);
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 0;
}
.el-dialog__header {
  padding: 0;
}
</style>
<style scoped>
.message-dialog {
  display: flex;
  /* height: 560px; */
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
}

/* 左侧tab区域 */
.left-tabs {
  width: 250px;
  background: #fff;
  padding: 45px 19px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tab-item {
  display: flex;
  align-items: center;
  padding: 17px 26px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: #f6f6f6;
  position: relative;
  line-height: normal;
}

.tab-item:hover {
  background: #e8f0fe;
}

.tab-item.active {
  background: #e8f0fe;
}

.tab-icon-img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

.tab-label {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  transition: color 0.3s;
}

.tab-item.active .tab-label {
  color: #1869ff;
  font-weight: 500;
}

.badge {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff4d4f;
  color: #ffffff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 分割线 */
.divider {
  width: 1px;
  background: #e2e2e2;
}

/* 右侧内容区 */
.right-content {
  flex: 1;
  padding: 24px 25px;
  height: 600px;
  overflow-y: auto;
}

/* 消息卡片 */
.msg-card {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 14px 20px 14px 30px;
  margin-bottom: 12px;
  line-height: normal;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.toggle-btn {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #333333;
}

.toggle-icon-img {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.toggle-icon-rotated {
  transform: rotate(180deg);
}

.card-body {
  margin-top: 12px;
}

.card-text {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  word-break: break-all;
}

/* 审核消息卡片 */
.review-card {
  padding: 14px 20px 14px 30px;
}

.review-content {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  position: relative;
}

.bullet {
  width: 9px;
  height: 9px;
  background: #ff0000;
  border-radius: 50%;
  position: absolute;
  left: -14px;
  top: calc(50% - 4.5px);
}

.review-title {
  font-weight: 600;
  color: #333333;
  white-space: nowrap;
  flex-shrink: 0;
}

.review-text {
  color: #666666;
  flex: 1;
}

.detail-link {
  color: #333333;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  line-height: 18px;
  gap: 5px;
}

/* 滚动条样式 */
.right-content::-webkit-scrollbar {
  width: 6px;
}

.right-content::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.right-content::-webkit-scrollbar-track {
  background: transparent;
}

.msg-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
